import React, { useState } from 'react';
import { makeStyles, InputBase, fade } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.primary.main, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.25),
    },
    width: 'auto',
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '0px',
    maxWidth: '40vw',
    '&:focus': {
      width: 200,
    },
    [theme.breakpoints.up('sm')]: {
      width: 120,
    },
  },
}));

function SearchField() {
  const classes = useStyles();
  const history = useHistory();
  const [value, setValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push(`/student/s/${value}`);
  };

  return (
    <form className={classes.search} onSubmit={handleSubmit}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <InputBase
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Tìm học sinh…"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        inputProps={{ 'aria-label': 'search' }}
        type="search"
        required
      />
    </form>
  );
}

export default SearchField;
